<template>

    <question-base :required="answerRequired"
                   :next-button-text="translations.nextButtonText"
                   :back-button-text="translations.backButtonText"
                   :back-button-enabled="backButtonEnabled"
                   :skip-button-text="translations.skipButtonText"
                   @skip="skipClicked"
                   @next="nextClicked"
                   @back="backClicked"
                   :background-color="backgroundColor"
                   :button-color="buttonColor"
                   :saving="loading">

        <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

            <validation-provider
                ref="validationProvider"
                :name="variable.name"
                :rules="rules"
                mode="lazy"
                v-slot="{ errors }">

                <question-header :background-color="backgroundColor"
                                 :question-text="questionText"
                                 :button-color="buttonColor"
                ></question-header>

                <vue-tel-input v-model="model"
                               class="pa-3 mt-4 mb-7"
                               autofocus
                               :only-countries="onlyCountries"
                               @validate="validatePhone"
                               :placeholder="translations.survey_please_enter_your_answer_here"
                               :wrapperClasses="wrapperClasses"
                               :inputClasses="inputClasses"
                               @keydown.enter="nextClicked"
                ></vue-tel-input>

                <div v-show="errors.length > 0" class="error-message caption red--text">
                    {{errors[0]}}
                </div>

            </validation-provider>

        </validation-observer>

    </question-base>
</template>

<script>

import {VueTelInput} from 'vue-tel-input'
import questionMixin from "./questionMixin";
import QuestionHeader from "./QuestionHeader";
import QuestionBase from "./QuestionBase";
import colorMixin from "./colorMixin";
import Json from 'vue-json-pretty';

export default {

    mixins: [questionMixin, colorMixin],

    components: {
        QuestionHeader,
        QuestionBase,
        VueTelInput,
        Json,
    },

    props: {

        value: {
            type: Number | null,
            required: false,
            default: null
        }
    },

    data() {
        return {
            valid: false,
            number: null,
        }
    },

    computed: {
        onlyCountries() {
            return [this.locale.code.substring(4, 7)];
        },

        wrapperClasses() {
            if (this.isDarkColor(this.backgroundColor)) {
                return ['wrapper-dark', 'elevation-1'];
            } else {
                return ['wrapper-light', 'elevation-1'];
            }
        },

        inputClasses() {
            if (this.isDarkColor(this.backgroundColor)) {
                return ['input-dark', 'body-1', 'grey--text', 'text--lighten-2'];
            } else {
                return ['input-light', 'body-1'];
            }
        }
    },

    methods: {

        validatePhone({number, isValid, country}) {

            this.number = number.e164;
            this.valid = isValid;

            if (!isValid && this.model) {
                this.addInvalidPhoneNumberError();
            }
        },

        addInvalidPhoneNumberError() {
            let errors = [];

            if (this.translations.survey_invalid_phone) {
                errors = [this.translations.survey_invalid_phone];
            } else {
                errors = ['Invalid phone number!'];
            }

            // Add manual error
            this.$refs.validationProvider.applyResult({
                errors: errors,
                valid: false,
                failedRules: {}
            });
        },

        nextClicked() {

            if (this.$refs.validationObserver) {

                this.$refs.validationObserver.validate()
                    .then(isValid => {

                        if (isValid) {

                            if (!this.valid) {
                                this.addInvalidPhoneNumberError();
                                return;
                            }

                            this.$emit('input', this.number);
                        }
                    });
            }
        },
    }
}
</script>

<style>

.vti__dropdown-list {
    padding: 0px !important;
    margin: 0px !important;
}

.wrapper-light {
    border: 0px;
    background-color: white;
    border-radius: 5px;
    padding-top: 6px;
    padding-bottom: 6px;
}

.wrapper-light div {
    background-color: white !important;
}

.wrapper-dark {
    border: 0px !important;
    background-color: #424242;
    border-radius: 5px;
    padding-top: 6px;
    padding-bottom: 6px;
}

.wrapper-dark div {
    padding: 0px !important;
    margin: 0px !important;
    background-color: #424242 !important;
}

.error-message {
    position: relative;
    top: -15px;
    left: 3px;
}

</style>
